"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var components_1 = require("../components");
var Form_1 = require("../Form");
var DateField_1 = __importDefault(require("./DateField"));
var DateRangeField = function (_a) {
    var fromLabel = _a.fromLabel, fromName = _a.fromName, toLabel = _a.toLabel, toName = _a.toName, className = _a.className, defaultOd = _a.defaultOd, defaultDo = _a.defaultDo, toolTipFrom = _a.toolTipFrom, toolTipTo = _a.toolTipTo, defValueOd = _a.defValueOd, defValueDo = _a.defValueDo, size = _a.size, maxDate = _a.maxDate;
    var values = Form_1.useFormContext().values;
    var fromValue = ramda_1.path(fromName.split('.'), values);
    var toValue = ramda_1.path(toName.split('.'), values);
    var fromValueDate;
    if (fromValue) {
        fromValueDate = new Date(fromValue);
    }
    var toValueDate;
    if (toValue) {
        toValueDate = new Date(toValue);
    }
    return (react_1.default.createElement(components_1.Field, { noStyles: true },
        react_1.default.createElement("div", { className: className },
            react_1.default.createElement(DateField_1.default, { label: fromLabel, name: fromName, maxDate: toValueDate, defaultValue: defaultOd, toolTip: toolTipFrom, defValue: defValueOd, size: size }),
            react_1.default.createElement(DateField_1.default, { label: toLabel, name: toName, minDate: fromValueDate, maxDate: maxDate ? new Date(maxDate) : undefined, defaultValue: defaultDo, toolTip: toolTipTo, defValue: defValueDo, size: size }))));
};
DateRangeField.defaultProps = {
    className: undefined,
    defaultOd: undefined,
    defaultDo: undefined,
    toolTipFrom: undefined,
    toolTipTo: undefined,
    defValueDo: undefined,
    defValueOd: undefined,
    size: undefined,
};
exports.default = styled_components_1.default(DateRangeField)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
